import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CACHE } from 'app/core/cache/cache.interceptor';

const maxAge = 3600000; // 1 Hour

export interface CacheEntry {
    url: string;
    response: HttpResponse<any>;
    lastRead: number;
}

@Injectable({
    providedIn: 'root',
})
export class CacheService {
    cache = new Map<string, CacheEntry>();

    get(req: HttpRequest<any>): HttpResponse<any> | undefined {
        const url = req.urlWithParams;
        const cached = this.cache.get(url);

        if (!cached) {
            return undefined;
        }

        const cache = req.context.get(CACHE);
        const ttl = typeof cache === 'number' ? cache * 1000 : maxAge;
        const isExpired = cached.lastRead < Date.now() - ttl;

        if (isExpired) {
            this.cache.delete(url);
            return undefined;
        }

        return cached.response;
    }

    put(req: HttpRequest<any>, response: HttpResponse<any>): void {
        const url = req.url;
        const cacheEntry: CacheEntry = { url, response, lastRead: Date.now() };
        this.cache.set(url, cacheEntry);
    }
}
